import React from "react";
function WebisteTerms({goBack}) {
  return (
    <div className="websiteterm-section">


    {/* GO BACK */}
{/* 
         <button onClick={goBack} className="back-btn">
        ← Go Back
      </button> */}

      <h1>Website Terms of Use</h1>
      <p> This website, located at https://www.aayurcare.com
 (“Site”), is owned and operated by Aayur Care, a medical
 disbursement company operating under Aayur Enterprises, which is registered as a Micro, Small, and Medium
 Enterprise (MSME) under the MSMED Act, 2006 in India</p>

 <p> The registered office is located at:
 Crescent Workspace, next to Karnataka Bank, HRBR Layout 1st Block, Bank Avenue Colony, Banaswadi, Bengaluru,
 Karnataka– 560043, India</p>


<p>These Terms of Use (“Terms”) govern your access to and use of this Site. By accessing or using the Site, you
 acknowledge that you have read, understood, and agree to be bound by these Terms and all applicable Indian laws
 and regulations</p>


<h3> 1. Eligibility</h3>
<p> By using this Site, you confirm that you are at least 18 years of age and legally competent under the Indian Contract
 Act, 1872 to enter into a binding agreement. If you are accessing or using this Site on behalf of another person or
 entity, you represent that you have the authority to bind such person or entity to these Terms.</p>

 <h3> 2. License to Use the Site</h3>
 <p>Aayur Care grants you a limited, non-transferable, revocable, non-exclusive license to use the Site for your personal,
 non-commercial use, in accordance with these Terms. This license does not allow any resale or commercial use of
 the Site or its contents.</p>

 <h3> 3. Restrictions</h3>
 <p> You agree not to modify, copy, reproduce, republish, upload, post, transmit, or distribute any part of the Site;
 reverse engineer or attempt to derive the source code of any part of the Site; use the Site to violate any applicable
 law, regulation, or third-party rights; employ bots, crawlers, data mining tools, or other automated methods to
 access or interact with the Site; or attempt to disrupt the Site’s functionality or gain unauthorized access to any part
 of the Site or its systems.</p>


 <h3> 4. User Content</h3>
 <p> You may be required to upload certain documents to access or use Aayur Care’s medical reimbursement services.
 You are solely responsible for the authenticity, accuracy, and legality of any documents you upload through the Site.
 You acknowledge that uploading forged, false, or unauthorized documents may result in rejection of services and
 potential legal action under applicable laws.Aayur Care does not permit public posting, sharing, or interaction by users on the Site. All uploaded content is for
 internal processing only and remains confidential in accordance with our Privacy Policy.
  We reserve the right to remove or reject any uploaded documents that violate our service policies, terms, or any
 applicable laws, or that appear fraudulent, misleading, or inappropriate.
</p>


<h3>5. Privacy Policy</h3>
<p> Your use of the Site is governed by our Privacy Policy, which outlines how we collect, use, and protect your personal
 information in accordance with the Information Technology Act, 2000 and the SPDI Rules.</p>

 <h3>6. Intellectual Property</h3>
 <p> All intellectual property on the Site, including trademarks, service marks, logos, text, graphics, and software, are the
 exclusive property of Aayur Enterprises or its licensors and are protected under the Indian Copyright Act, 1957, the
 Trademarks Act, 1999, and other applicable laws. Aayur Care, a brand and operational entity under Aayur
 Enterprises, uses this intellectual property solely in accordance with the rights granted by Aayur Enterprises.</p>


 <h3> 7. Medical Reimbursement Disclaimer</h3>
 <p> The Site provides access to medical reimbursement services and related information.
   {/* Insurance-related services,
 where applicable, are facilitated through licensed intermediaries under arrangements compliant with the regulatory
 framework of the Insurance Regulatory and Development Authority of India (IRDAI). */}
  Use of this Site does not
 constitute a guarantee of claim settlement. All claims are subject to verification, documentation, and compliance
 with applicable laws, policies, and the terms of our service partners.</p>

 <h3>8. Cookies</h3>
 <p> We use cookies to enhance user experience and analyze site traffic. By using the Site, you consent to our use of
 cookies in accordance with our Privacy Policy.</p>

 <h3> 9. Third-Party Links</h3>
 <p>The Site may contain links to external websites or third-party services for your convenience. Aayur Care does not
 control, endorse, or assume responsibility for the content, accuracy, or practices of any third-party websites or
 services. Accessing or using such third-party resources is at your own discretion and risk. Aayur Care shall not be
 liable for any loss or damage arising from your reliance on or interaction with third-party content. Users are advised
 to review the terms and privacy policies of such third-party platforms before use.</p>

 <h3>10. Legal & Compliance</h3>
 {/* <p>All insurance-related services are provided through Vibe Insurance under IRDAI guidelines. Aayur Care acts as a
 support and advisory platform under the POSP (Point of Sales Person) framework. It does not underwrite or directly
 sell insurance policies</p> */}
 <p>All services other than opd providing through our channel partners.Aayurcare acts as a facilitator 
  framework only.
 </p>

 <h3>11. Limitation of Liability</h3>
 <p> To the fullest extent permitted under applicable Indian law, Aayur Care (operating under Aayur Enterprises) shall not
 be liable for any direct, indirect, incidental, special, consequential, or exemplary damages — including, but not
 limited to, loss of profits, data, business interruption, goodwill, or other intangible losses — arising out of or related
 to your access to, use of, or inability to use the Site or any of its services, even if we have been advised of the
 possibility of such damages</p>

 <h3>12. Indemnity</h3>
 <p> You agree to indemnify, defend, and hold harmless Aayur Care (operating under Aayur Enterprises), its affiliates,
 officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, costs, and
 expenses (including reasonable legal fees) arising out of or related to:
 your use or misuse of the Site or services,
 your violation of these Terms of Use, or
 your violation of any applicable laws, regulations, or rights of a third party.</p>

 <h3> 13. Termination</h3>
 <p> Aayur Care (operating under Aayur Enterprises) reserves the right to suspend or terminate your access to the Site or
 its services at any time, without prior notice, if you violate these Terms of Use, applicable laws, or engage in any
 conduct that is unlawful, harmful, or otherwise inappropriate.
 Upon termination, all rights granted to you under these Terms shall immediately cease, and you must discontinue all
 use of the Site</p>

 <h3>14. Governing Law and Jurisdiction</h3>
 <p>These Terms shall be governed by and interpreted in accordance with the laws of India. Any disputes arising out of
 or in connection with these Terms, the Site, or its services shall be subject to the exclusive jurisdiction of the courts
 located in Bangalore, Karnataka.</p>

 <h3> 15. Grievance Officer (as per IT Act, 2000)</h3>
 <p> For any complaints or concerns regarding content or services, you may contact our Grievance Officer:
 Email: grievance@aayurcare.com
 Address: Crescent Workspace, next to karnataka bank, HRBR Layout 1st Block, Bank Avenue Colony, Banaswadi,
 Bengaluru, Karnataka 560043
</p>

<h3>16. Modification</h3>
<p> Aayur Care (operating under Aayur Enterprises) reserves the right to modify, update, or revise these Terms of Use at
 any time, at its sole discretion, in accordance with applicable Indian laws.
 In the event of any material changes, users will be notified through updates posted on the Site. It is your
 responsibility to review the Terms periodically. Continued use of the Site after such changes shall constitute your
 acceptance of the revised Terms.
 Aayur Care does not guarantee separate or personal notifications for each user.</p>

 <h3> 17. Copyright and Trademark Information</h3>
 <p> All content, text, graphics, software, and materials available on the Site are protected under the Indian Copyright
 Act, 1957 and other applicable intellectual property laws. Unauthorized use, reproduction, or distribution of any
 content from this Site may result in civil and/or criminal liability under Indian law. All trademarks, service marks, and
 logos displayed on the Site are the property of Aayur Enterprises or are used under valid license. Aayur Care, as a
 platform and brand, operates under Aayur Enterprises, and all rights are reserved accordingly.</p>


 <h3>18. Contact Information</h3>
 <p> Company Name:AayurCare (poweredby Aayur Enterprises)
  <br></br>
 Registered Address: Crescent Workspace, next to Karnataka Bank, HRBR Layout 1st Block, Bank Avenue Colony,
 Banaswadi, Bengaluru, Karnataka– 560043, India
 <br></br>
 Operating Address: BHIVE Premium Koramangala (Near Nexus Mall), Hosur Main Road, next to Forum Mall, Adugodi,
 Koramangala, Bengaluru, Karnataka– 560030, India
 Official Email for Contact & Communication: info@aayurcare.com</p>
  























      
    </div>
  );
}

export default WebisteTerms;
